/**
 * Agent type values
 */
export enum AgentTypeEnum {
	EVENT_ORGANIZER = 'event_organizer',
	TRAVEL_AGENCY = 'travel_agency',
	TOUR_OPERATOR = 'tour_operator',
	ONLINE_BOOKING_PLATFORM = 'online_booking_platform',
	CORPORATE_CLIENT = 'corporate_client',
	GOVERNMENT_OR_PUBLIC_AGENCY = 'government_or_public_agency',
	INDIVIDUAL_AGENT = 'individual_agent',
	PARTNER_COMPANY = 'partner_company',
	HOTEL_RESORT = 'hotel_resort',
	HOSTEL = 'hostel',
	OTHER = 'other',
}
